
import { Nullable } from '@/types/types';
import Vue from 'vue';
import { addHours, format } from 'date-fns';
import localeFr from 'date-fns/locale/fr';
import parseISO from 'date-fns/parseISO';

export default Vue.extend({
  name: 'DatePicker',
  props: {
    value: {
      type: Date as any as () => Nullable<Date>,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default: () => [] as any[]
    },
    clearable: {
      type: Boolean,
      default: false
    },
    dateFormat: {
      type: String,
      default: 'dd/MM/yyyy'
    },
    allowedDates: {
      type: Function,
      default: () => () => true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    inner_value: null as string,
    showPicker: false
  }),
  computed: {
    text (): string {
      return this.value ? format(parseISO(this.inner_value), this.dateFormat, { locale: localeFr }) : null;
    }
  },
  watch: {
    value () {
      this.updateInnerValue();
    }
  },
  created () {
    this.updateInnerValue();
  },
  methods: {
    updateInnerValue () {
      this.inner_value = this.value ? format(this.value, 'yyyy-MM-dd') : null;
    },
    onChange () {
      this.showPicker = false;
      this.updateValue();
    },
    cancel () {
      this.updateInnerValue();
      this.showPicker = false;
    },
    clearValue () {
      this.inner_value = null;
      this.updateValue();
    },
    updateValue () {
      const _value = this.inner_value ? addHours(parseISO(this.inner_value), 12) : null;

      this.$emit('input', _value);
    }
  }
});
